// extracted by mini-css-extract-plugin
export default {"input":"input_input__YUePt","block":"input_block__Xj2X3"};